// import React, { useState, useEffect } from "react";
// import { Heart, Eye, ShoppingCart, X } from "lucide-react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useMenu } from "../../../context/MenuContext";
// import ProductGridSkeleton from "../../../skeletons/ProductGridSkeleton";
// import Swal from "sweetalert2";

// const colorClass = {
//   red: "bg-red-500",
//   blue: "bg-blue-500",
//   green: "bg-green-500",
//   black: "bg-black",
//   white: "bg-white border",
//   yellow: "bg-yellow-400",
//   gray: "bg-gray-500",
//   "royal blue": "bg-blue-700",
// };

// const Men = () => {
//   const [productsData, setProductsData] = useState([]);
//   const [hoverImages, setHoverImages] = useState({});
//   const [relatedHoverImages, setRelatedHoverImages] = useState({});
//   const [sortBy, setSortBy] = useState("Latest");
//   const [loading, setLoading] = useState(true);
//   const [popupImage, setPopupImage] = useState(null);

//   const navigate = useNavigate();
//   const { slug } = useParams();

//   // ✅ get context values
//   const { fetchMenuCounts, setCartCount, setWishlistCount } = useMenu();

//   // 🔹 Fetch products by slug
//   useEffect(() => {
//     setLoading(true);
//     fetch(
//       `https://tyka.premierhostings.com/backend/api/child-category/${slug}/products`
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         const products = data?.data?.products || [];
//         setProductsData(products);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching products:", err);
//         setLoading(false);
//       });
//   }, [slug]);

//   // 🔹 Sort products
//   const sortProducts = (products) => {
//     if (!Array.isArray(products)) return [];
//     switch (sortBy) {
//       case "Older":
//         return [...products].reverse();
//       default:
//         return products;
//     }
//   };

//   // 🔹 Color Hover Handling
//   const handleColorHover = (productId, image) => {
//     if (image) setHoverImages((prev) => ({ ...prev, [productId]: image }));
//   };

//   const handleColorLeave = (productId) => {
//     setHoverImages((prev) => {
//       const updated = { ...prev };
//       delete updated[productId];
//       return updated;
//     });
//   };

//   const handleRelatedColorHover = (productId, image) => {
//     if (image)
//       setRelatedHoverImages((prev) => ({ ...prev, [productId]: image }));
//   };

//   const handleRelatedColorLeave = (productId) => {
//     setRelatedHoverImages((prev) => {
//       const updated = { ...prev };
//       delete updated[productId];
//       return updated;
//     });
//   };

//   // 🔹 Add to Cart
//   const handleAddToCart = async (e, product) => {
//     e.stopPropagation();
//     if (!product?.id) return;

//     const payload = {
//       product_id: product.id,
//       color_id: product?.variants?.[0]?.color_id || null,
//       size_id: product?.variants?.[0]?.size_id || null,
//       quantity: 1,
//     };

//     try {
//       const authToken = localStorage.getItem("authToken");
//       let guestToken = localStorage.getItem("guest_token");
//       let url = `https://tyka.premierhostings.com/backend/api/cart`;
//       let headers = { "Content-Type": "application/json" };
//       let id = localStorage.getItem("authUserId");
//       if (authToken) {
//         headers.Authorization = `Bearer ${authToken}`;
//       } else if (guestToken) {
//         url += `?guest_token=${guestToken}`;
//       }

//       const res = await fetch(url, {
//         method: "POST",
//         headers,
//         body: JSON.stringify(payload),
//       });
//       const data = await res.json();

//       if (data.success) {
//         if (!authToken && data.guest_token) {
//           localStorage.setItem("guest_token", data.guest_token);
//         }

//         if (!authToken) {
//           debugger;
//           setCartCount((prev) => prev + 1); // ✅ Guest update instantly
//         } else {
//           fetchMenuCounts(id, authToken);
//           // fetchMenuCounts(); // ✅ Logged in update via API
//         }

//         Swal.fire("✅ Added to Cart!", "", "success");
//       } else {
//         Swal.fire("Failed!", data.message || "Failed to add to cart", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error!", "Something went wrong!", "error");
//     }
//   };

//   // 🔹 Add to Wishlist (Guest + Logged-in)
//   const handleAddToWishlist = async (e, product) => {
//     e.stopPropagation();
//     if (!product?.id) return;

//     const payload = {
//       product_id: product.id,
//       color_id: product?.variants?.[0]?.color_id || null,
//       size_id: product?.variants?.[0]?.size_id || null,
//       quantity: 1,
//     };

//     try {
//       const authToken = localStorage.getItem("authToken");
//       let guestToken = localStorage.getItem("guest_token");
//       let id = localStorage.getItem("authUserId");

//       let url = `https://tyka.premierhostings.com/backend/api/wishlists`;
//       let headers = { "Content-Type": "application/json" };

//       if (authToken) {
//         headers.Authorization = `Bearer ${authToken}`;
//       } else if (guestToken) {
//         url += `?guest_token=${guestToken}`;
//       }

//       const res = await fetch(url, {
//         method: "POST",
//         headers,
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();

//       if (data.success) {
//         if (!authToken && data.guest_token) {
//           localStorage.setItem("guest_token", data.guest_token);
//         }

//         if (!authToken) {
//           console.log("helloo");
//           debugger;
//           setWishlistCount((prev) => prev + 1); // ✅ Guest update instantly
//         } else {
//           console.log("sdhufuivdhuxhv", id, authToken);
//           debugger;
//           fetchMenuCounts(id, authToken);
//         }

//         Swal.fire("💖 Added to Wishlist!", "", "success");
//       } else {
//         Swal.fire(
//           "Failed!",
//           data.message || "Failed to add to wishlist",
//           "error"
//         );
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire("Error!", "Something went wrong!", "error");
//     }
//   };

//   // 🔹 Color bar renderer
//   const colorBar = (product, isRelated = false) => {
//     const uniqueColors = product.variants
//       ? [...new Map(product.variants.map((v) => [v.color?.id, v])).values()]
//       : [];

//     return (
//       <div className="flex h-[4px] w-full">
//         {uniqueColors.map((variant, index) => {
//           const color = variant.color;
//           const colorHex = color?.hexa_code;
//           const colorName = color?.name?.toLowerCase();
//           const variantImage = variant.variant_default_image;

//           return (
//             <div
//               key={index}
//               className={`w-full h-full cursor-pointer ${
//                 !colorHex ? colorClass[colorName] || "bg-gray-400" : ""
//               }`}
//               style={colorHex ? { backgroundColor: colorHex } : {}}
//               onMouseEnter={() =>
//                 isRelated
//                   ? handleRelatedColorHover(product.id, variantImage)
//                   : handleColorHover(product.id, variantImage)
//               }
//               onMouseLeave={() =>
//                 isRelated
//                   ? handleRelatedColorLeave(product.id)
//                   : handleColorLeave(product.id)
//               }
//             />
//           );
//         })}
//       </div>
//     );
//   };

//   const displayedProducts = Array.isArray(productsData)
//     ? sortProducts(productsData)
//     : [];

//   if (loading) return <ProductGridSkeleton />;

//   return (
//     <div className="max-w-7xl mx-auto px-6 py-6">
//       {/* Header: Count + Sorting */}
//       <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
//         <h2 className="text-xl font-semibold">
//           Showing {displayedProducts.length} Products
//         </h2>
//         <div className="relative w-full sm:w-auto">
//           <select
//             value={sortBy}
//             onChange={(e) => setSortBy(e.target.value)}
//             className="appearance-none text-m text-gray-700 border border-gray-300 rounded px-3 py-2 w-full sm:w-auto pr-6 cursor-pointer focus:outline-none "
//           >
//             <option value="Latest">Sort by latest</option>
//             <option value="Older">Sort by older</option>
//           </select>
//           <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500 ">
//             ⏷
//           </span>
//         </div>
//       </div>

//       {/* Product Grid */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 ">
//         {displayedProducts.map((product) => (
//           <div
//             key={product.id}
//             className="relative group"
//             onClick={() => navigate(`/productpage/${product.slug}`)}
//           >
//             <div className="">
//               <img
//                 src={
//                   hoverImages[product.id] ||
//                   relatedHoverImages[product.id] ||
//                   product.default_image ||
//                   "/placeholder.png"
//                 }
//                 alt={product.name}
//                 className="w-full h-[220px] sm:h-[260px] md:h-[280px] lg:h-[430px] object-contain"
//               />
//               {/* Color bar */}
//               {/* <div className="" style={{ marginTop: "-13px" }}>
//                 {colorBar(product)}
//               </div> */}

//               {/* Hover Buttons */}
//               <div className="absolute top-4 right-4 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition lg:mt-4 lg:gap-3 md:mr-2">
//                 <button
//                   className="bg-white p-1 rounded shadow"
//                   onClick={(e) => handleAddToWishlist(e, product)}
//                 >
//                   <Heart size={16} />
//                 </button>
//                 <button
//                   className="bg-white p-1 rounded shadow"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     setPopupImage(
//                       hoverImages[product.id] ||
//                         relatedHoverImages[product.id] ||
//                         product.default_image
//                     );
//                   }}
//                 >
//                   <Eye size={16} />
//                 </button>
//                 <button
//                   className="bg-white p-1 rounded shadow"
//                   onClick={(e) => handleAddToCart(e, product)}
//                 >
//                   <ShoppingCart size={16} />
//                 </button>
//               </div>
//             </div>

//             {/* Product Info */}
//             <div className="mt-2 text-left">
//               <div className="" style={{ marginTop: "-21px" }}>
//                 {colorBar(product)}
//               </div>
//               <h4 className="text-sm font-semibold">{product.name}</h4>
//               <p className="text-red-600 font-bold mt-1">
//                 ₹
//                 {product.price ||
//                   product.selling_price ||
//                   product.cost_price ||
//                   "N/A"}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Image Popup Modal */}
//       {popupImage && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
//           onClick={() => setPopupImage(null)}
//         >
//           <div
//             className="relative max-w-2xl w-3/4 p-4"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute top-2 right-2 bg-white rounded-full p-1"
//               onClick={() => setPopupImage(null)}
//             >
//               <X size={20} />
//             </button>
//             <img
//               src={popupImage}
//               alt="Product Preview"
//               className="w-full h-auto max-h-[90vh] object-contain rounded"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Men;

import React, { useState, useEffect } from "react";
import { Heart, Eye, ShoppingCart, X } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useMenu } from "../../../context/MenuContext";
import ProductGridSkeleton from "../../../skeletons/ProductGridSkeleton";
import Swal from "sweetalert2";

const colorClass = {
  red: "bg-red-500",
  blue: "bg-blue-500",
  green: "bg-green-500",
  black: "bg-black",
  white: "bg-white border",
  yellow: "bg-yellow-400",
  gray: "bg-gray-500",
  "royal blue": "bg-blue-700",
};

const Men = () => {
  const [productsData, setProductsData] = useState([]);
  const [hoverImages, setHoverImages] = useState({});
  const [relatedHoverImages, setRelatedHoverImages] = useState({});
  const [sortBy, setSortBy] = useState("Latest");
  const [loading, setLoading] = useState(true);
  const [popupImage, setPopupImage] = useState(null);

  const navigate = useNavigate();
  const { slug } = useParams();

  // ✅ get context values
  const { fetchMenuCounts, setCartCount, setWishlistCount } = useMenu();

  // 🔹 Fetch products by slug
  useEffect(() => {
    setLoading(true);
    const categorySlugs = ["men", "women", "accessories", "cricket"];
    const apiUrl = categorySlugs.includes(slug)
      ? `https://tyka.premierhostings.com/backend/api/category/${slug}/products`
      : `https://tyka.premierhostings.com/backend/api/child-category/${slug}/products`;

    fetch(apiUrl)
    // fetch(
    //   `https://tyka.premierhostings.com/backend/api/child-category/${slug}/products`
    // )
      .then((res) => res.json())
      .then((data) => {
        const products = data?.data?.products || [];
        setProductsData(products);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
        setLoading(false);
      });
  }, [slug]);

  // 🔹 Sort products
  const sortProducts = (products) => {
    if (!Array.isArray(products)) return [];
    switch (sortBy) {
      case "Older":
        return [...products].reverse();
      default:
        return products;
    }
  };

  // 🔹 Color Hover Handling
  const handleColorHover = (productId, image) => {
    if (image) setHoverImages((prev) => ({ ...prev, [productId]: image }));
  };

  const handleColorLeave = (productId) => {
    setHoverImages((prev) => {
      const updated = { ...prev };
      delete updated[productId];
      return updated;
    });
  };

  const handleRelatedColorHover = (productId, image) => {
    if (image)
      setRelatedHoverImages((prev) => ({ ...prev, [productId]: image }));
  };

  const handleRelatedColorLeave = (productId) => {
    setRelatedHoverImages((prev) => {
      const updated = { ...prev };
      delete updated[productId];
      return updated;
    });
  };

  // 🔹 Add to Cart
  const handleAddToCart = async (e, product) => {
    e.stopPropagation();
    if (!product?.id) return;

    const payload = {
      product_id: product.id,
      color_id: product?.variants?.[0]?.color_id || null,
      size_id: product?.variants?.[0]?.size_id || null,
      quantity: 1,
    };

    try {
      const authToken = localStorage.getItem("authToken");
      let guestToken = localStorage.getItem("guest_token");
      let url = `https://tyka.premierhostings.com/backend/api/cart`;
      let headers = { "Content-Type": "application/json" };
      let id = localStorage.getItem("authUserId");
      if (authToken) {
        headers.Authorization = `Bearer ${authToken}`;
      } else if (guestToken) {
        url += `?guest_token=${guestToken}`;
      }

      const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (data.success) {
        if (!authToken && data.guest_token) {
          localStorage.setItem("guest_token", data.guest_token);
        }

        if (!authToken) {
          setCartCount((prev) => prev + 1); // ✅ Guest update instantly
        } else {
          fetchMenuCounts(id, authToken);
          // fetchMenuCounts(); // ✅ Logged in update via API
        }

        Swal.fire("✅ Added to Cart!", "", "success");
      } else {
        Swal.fire("Failed!", data.message || "Failed to add to cart", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Something went wrong!", "error");
    }
  };

  // 🔹 Add to Wishlist (Guest + Logged-in)
  const handleAddToWishlist = async (e, product) => {
    e.stopPropagation();
    if (!product?.id) return;

    const payload = {
      product_id: product.id,
      color_id: product?.variants?.[0]?.color_id || null,
      size_id: product?.variants?.[0]?.size_id || null,
      quantity: 1,
    };

    try {
      const authToken = localStorage.getItem("authToken");
      let guestToken = localStorage.getItem("guest_token");
      let id = localStorage.getItem("authUserId");

      let url = "https://tyka.premierhostings.com/backend/api/wishlists";
      let headers = { "Content-Type": "application/json" };

      if (authToken) {
        headers.Authorization = `Bearer ${authToken}`;
      } else if (guestToken) {
        url += `?guest_token=${guestToken}`;
      }

      const res = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.success) {
        if (!authToken && data.guest_token) {
          localStorage.setItem("guest_token", data.guest_token);
        }

        if (!authToken) {
          setWishlistCount((prev) => prev + 1); // ✅ Guest update instantly
        } else {
          fetchMenuCounts(id, authToken);
        }

        Swal.fire("💖 Added to Wishlist!", "", "success");
      } else {
        Swal.fire(
          "Failed!",
          data.message || "Failed to add to wishlist",
          "error"
        );
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Something went wrong!", "error");
    }
  };

  // 🔹 Color bar renderer
  const colorBar = (product, isRelated = false) => {
    const uniqueColors = product.variants
      ? [...new Map(product.variants.map((v) => [v.color?.id, v])).values()]
      : [];

    return (
      <div className="flex h-[4px] w-full">
        {uniqueColors.map((variant, index) => {
          const color = variant.color;
          const colorHex = color?.hexa_code;
          const colorName = color?.name?.toLowerCase();
          const variantImage = variant.variant_default_image;

          return (
            <div
              key={index}
              className={`w-full h-full cursor-pointer ${
                !colorHex ? colorClass[colorName] || "bg-gray-400" : ""
              }`}
              style={colorHex ? { backgroundColor: colorHex } : {}}
              onMouseEnter={() =>
                isRelated
                  ? handleRelatedColorHover(product.id, variantImage)
                  : handleColorHover(product.id, variantImage)
              }
              onMouseLeave={() =>
                isRelated
                  ? handleRelatedColorLeave(product.id)
                  : handleColorLeave(product.id)
              }
            />
          );
        })}
      </div>
    );
  };

  const displayedProducts = Array.isArray(productsData)
    ? sortProducts(productsData)
    : [];

  if (loading) return <ProductGridSkeleton />;

  return (
    <div className="max-w-7xl mx-auto px-6 py-6">
      {/* Header: Count + Sorting */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
        <h2 className="text-xl font-semibold">
          Showing {displayedProducts.length} Products
        </h2>
        <div className="relative w-full sm:w-auto">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="appearance-none text-m text-gray-700 border border-gray-300 rounded px-3 py-2 w-full sm:w-auto pr-6 cursor-pointer focus:outline-none "
          >
            <option value="Latest">Sort by latest</option>
            <option value="Older">Sort by older</option>
          </select>
          <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500 ">
            ⏷
          </span>
        </div>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 ">
        {displayedProducts.map((product) => (
          <div
            key={product.id}
            className="relative group"
            onClick={() => navigate(`/${product.slug}`)}
          >
            {/* MEDIA ONLY */}
            <div className="relative">
              {/* Product Image */}
              <img
                src={
                  hoverImages[product.id] ||
                  relatedHoverImages[product.id] ||
                  product.default_image ||
                  "/placeholder.png"
                }
                alt={product.name}
                className="w-full object-contain border"
              />

              {/* FULL-HEIGHT TRANSPARENT COLOR OVERLAY (scoped to image only) */}
              <div className="pointer-events-none absolute inset-0 z-10 flex">
                {(product.variants
                  ? [
                      ...new Map(
                        product.variants.map((v) => [v.color?.id, v])
                      ).values(),
                    ]
                  : []
                ).map((variant, index) => {
                  const color = variant.color;
                  const colorHex = color?.hexa_code;
                  const colorName = color?.name?.toLowerCase();
                  const variantImage = variant.variant_default_image;

                  const fallback = colorHex
                    ? colorHex
                    : {
                        red: "#ef4444",
                        blue: "#3b82f6",
                        green: "#22c55e",
                        black: "#000000",
                        white: "#ffffff",
                        yellow: "#facc15",
                        gray: "#6b7280",
                        "royal blue": "#1d4ed8",
                      }[colorName] || "#9ca3af";

                  return (
                    <div
                      key={index}
                      className="relative w-full h-full cursor-pointer pointer-events-auto"
                      onMouseEnter={() =>
                        handleColorHover(product.id, variantImage)
                      }
                      onMouseLeave={() => handleColorLeave(product.id)}
                      style={{ backgroundColor: "transparent" }}
                    >
                      {/* Visible 4px strip at the bottom */}
                      <div
                        className="absolute left-0 right-0 bottom-0 h-[4px]"
                        style={{
                          backgroundColor: fallback,
                          borderTop:
                            colorName === "white"
                              ? "1px solid #e5e7eb"
                              : "none",
                        }}
                      />
                    </div>
                  );
                })}
              </div>

              {/* Hover Buttons */}
              <div className="absolute top-2 sm:top-4 right-2 sm:right-4 z-20 flex flex-col gap-2 sm:gap-3 opacity-0 group-hover:opacity-100 transition">
                <button
                  className="bg-white p-1 rounded shadow"
                  onClick={(e) => handleAddToWishlist(e, product)}
                >
                  <Heart size={16} />
                </button>
                <button
                  className="bg-white p-1 rounded shadow"
                  onClick={(e) => {
                    e.stopPropagation();
                    setPopupImage(
                      hoverImages[product.id] ||
                        relatedHoverImages[product.id] ||
                        product.default_image
                    );
                  }}
                >
                  <Eye size={16} />
                </button>
                <button
                  className="bg-white p-1 rounded shadow"
                  onClick={(e) => handleAddToCart(e, product)}
                >
                  <ShoppingCart size={16} />
                </button>
              </div>
            </div>

            {/* INFO (outside the media wrapper so it won't be covered) */}
            <div className="text-left mt-2">
              {/* Optional: keep a thin color bar below the image too */}
              {/* {colorBar(product)} */}

              <h4 className="text-sm sm:text-base font-semibold">
                {product.name}
              </h4>

              {product.cost_price &&
              product.selling_price &&
              product.discount ? (
                <div className="flex items-center gap-3 mt-2">
                  <span className="text-lg text-gray-500 line-through">
                    ₹{product.cost_price}
                  </span>
                  <span className="text-lg font-bold text-red-600">
                    ₹{product.selling_price}
                  </span>
                </div>
              ) : (
                <p className="text-red-600 font-bold mt-2">
                  ₹
                  {product.selling_price ||
                    product.price ||
                    product.cost_price ||
                    "N/A"}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Image Popup Modal */}
      {popupImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setPopupImage(null)}
        >
          <div
            className="relative max-w-2xl w-3/4 p-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-2 right-2 bg-white rounded-full p-1"
              onClick={() => setPopupImage(null)}
            >
              <X size={20} />
            </button>
            <img
              src={popupImage}
              alt="Product Preview"
              className="w-full h-auto max-h-[90vh] object-contain rounded"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Men;
